import { EMapContainerAreaActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const changeMapContainerArea = actionGenerator<EMapContainerAreaActionType.Changed, number>(
  EMapContainerAreaActionType.Changed,
);
